import { RSAA } from 'redux-api-middleware';
import endpoints from '../../utils/endpoints';
import { getBacsDetails } from '../bacsCredit/selectors';
import { getReplacementDates } from '../calendar/selectors';
import {
	getBacsReviewRequest,
	getBacsConfirmedRequest,
	getBacsDebitReviewRequest,
	getBacsDebitConfirmedRequest,
} from '../../helpers/apiRequestBuilder/';
import { updateSubmissionDate } from '../bacsCredit/actions';
import { isAuthorisationEdit } from '../modes/selectors';
import { getBacsDetails as getBacsDebitDetails } from '../bacsDebit/selectors';
import { updateSubmissionDate as updateBacsDebitSubmissionDate } from '../bacsDebit/actions';
import { isPayingInternalAccountsWithoutBeneficiary } from '../payees/selectors';
import { submitBeneficiaries } from '../payees/actions';
import { getBankId } from '../session/selectors';
import { getUserId } from '../user/selectors';

export const SUBMIT_BACS_PAYMENT_REVIEW_REQUEST = 'SUBMIT_BACS_PAYMENT_REVIEW_REQUEST';
export const SUBMIT_BACS_PAYMENT_REVIEW_SUCCESS = 'SUBMIT_BACS_PAYMENT_REVIEW_SUCCESS';
export const SUBMIT_BACS_PAYMENT_REVIEW_FAILURE = 'SUBMIT_BACS_PAYMENT_REVIEW_FAILURE';

export const SUBMIT_CONFIRMED_BACS_PAYMENTS_REQUEST = 'SUBMIT_CONFIRMED_BACS_PAYMENTS_REQUEST';
export const SUBMIT_CONFIRMED_BACS_PAYMENTS_SUCCESS = 'SUBMIT_CONFIRMED_BACS_PAYMENTS_SUCCESS';
export const SUBMIT_CONFIRMED_BACS_PAYMENTS_FAILURE = 'SUBMIT_CONFIRMED_BACS_PAYMENTS_FAILURE';

export const SUBMIT_BACSDEBIT_PAYMENT_REVIEW_REQUEST = 'SUBMIT_BACSDEBIT_PAYMENT_REVIEW_REQUEST';
export const SUBMIT_BACSDEBIT_PAYMENT_REVIEW_SUCCESS = 'SUBMIT_BACSDEBIT_PAYMENT_REVIEW_SUCCESS';
export const SUBMIT_BACSDEBIT_PAYMENT_REVIEW_FAILURE = 'SUBMIT_BACSDEBIT_PAYMENT_REVIEW_FAILURE';

export const SUBMIT_CONFIRMED_BACSDEBIT_PAYMENTS_REQUEST = 'SUBMIT_CONFIRMED_BACSDEBIT_PAYMENTS_REQUEST';
export const SUBMIT_CONFIRMED_BACSDEBIT_PAYMENTS_SUCCESS = 'SUBMIT_CONFIRMED_BACSDEBIT_PAYMENTS_SUCCESS';
export const SUBMIT_CONFIRMED_BACSDEBIT_PAYMENTS_FAILURE = 'SUBMIT_CONFIRMED_BACSDEBIT_PAYMENTS_FAILURE';

export const submitBacsReview = (dispatch, getState) => {
	const state = getState();
	const bacsDetails = getBacsDetails(state);
	const body = getBacsReviewRequest(bacsDetails);

	const endpoint = endpoints.authorisation.uri;
	const userId = getUserId(state);
	const successAction = {
		type: SUBMIT_BACS_PAYMENT_REVIEW_SUCCESS,
		meta: { userId },
	};
	const action = {
		[RSAA]: {
			endpoint,
			method: 'POST',
			types: [SUBMIT_BACS_PAYMENT_REVIEW_REQUEST, successAction, SUBMIT_BACS_PAYMENT_REVIEW_FAILURE],
			body,
			headers: { 'x-bpi-version': endpoints.authorisation.x_bpi_version },
		},
	};
	return dispatch(action);
};

export const submitBacsPaymentsForReview = (beneficiaryId) => (dispatch, getState) => {
	const state = getState();
	let paymentsRequireBeneficiary = isPayingInternalAccountsWithoutBeneficiary(state, 'bacsCredit');

	if (paymentsRequireBeneficiary.length > 0 && !beneficiaryId) {
		//fixme: control with correct values in state
		paymentsRequireBeneficiary = paymentsRequireBeneficiary.map((payment) => ({
			...payment,
			fromAccount: state.bacsCredit.fromAccount,
		}));
		const bankId = getBankId(state);
		const { accounts } = state;
		return dispatch(submitBeneficiaries(bankId, paymentsRequireBeneficiary, accounts)).then(() =>
			submitBacsReview(dispatch, getState)
		);
	}
	return submitBacsReview(dispatch, getState);
};

export const submitConfirmedBacsPayments = (bacsDetails, payees) => {
	const body = getBacsConfirmedRequest(bacsDetails, payees);
	const endpoint = endpoints.createBacsCredit.resolve(null, null, bacsDetails.fromAccount);

	return {
		[RSAA]: {
			endpoint,
			method: 'POST',
			types: [
				SUBMIT_CONFIRMED_BACS_PAYMENTS_REQUEST,
				SUBMIT_CONFIRMED_BACS_PAYMENTS_SUCCESS,
				SUBMIT_CONFIRMED_BACS_PAYMENTS_FAILURE,
			],
			body,
			headers: { 'x-bpi-version': endpoints.createBacsCredit.x_bpi_version },
		},
	};
};

export const submitEditedBacsPaymentsRequest = (bacsDetails, payees, paymentContextId) => {
	const body = getBacsConfirmedRequest(bacsDetails, payees, paymentContextId);
	const endpoint = endpoints.createBacsCredit.resolve(null, null, bacsDetails.fromAccount);

	return {
		[RSAA]: {
			endpoint,
			method: 'PUT',
			types: [
				SUBMIT_CONFIRMED_BACS_PAYMENTS_REQUEST,
				SUBMIT_CONFIRMED_BACS_PAYMENTS_SUCCESS,
				SUBMIT_CONFIRMED_BACS_PAYMENTS_FAILURE,
			],
			body,
			headers: { 'x-bpi-version': endpoints.createBacsCredit.x_bpi_version },
		},
	};
};

export const submitConfirmedEditedBacsPayment = () => (dispatch, getState) => {
	const state = getState();
	const bacsDetails = getBacsDetails(state);
	return dispatch(submitEditedBacsPaymentsRequest(bacsDetails, state.payees, bacsDetails.context_id));
};

export const submitBacsConfirmed = () => (dispatch, getState) => {
	const state = getState();
	const bacsDetails = getBacsDetails(state);
	if (isAuthorisationEdit(state)) {
		return dispatch(submitConfirmedEditedBacsPayment());
	}
	return dispatch(submitConfirmedBacsPayments(bacsDetails, state.payees));
};

export const acceptDateChangeAndResubmit = (dispatch, getState) => {
	const state = getState();
	const bacsDetails = getBacsDetails(state);
	const { submission } = getReplacementDates(state);
	dispatch(updateSubmissionDate({ submissionDate: submission }));
	return dispatch(submitConfirmedBacsPayments(bacsDetails, state.payees));
};

export const submitBacsDebitReview = (dispatch, getState) => {
	const state = getState();
	const bacsDebitDetails = getBacsDebitDetails(state);
	const body = getBacsDebitReviewRequest(bacsDebitDetails);

	const userId = getUserId(state);
	const successAction = {
		type: SUBMIT_BACSDEBIT_PAYMENT_REVIEW_SUCCESS,
		meta: { userId },
	};

	const endpoint = endpoints.authorisation.uri;
	const action = {
		[RSAA]: {
			endpoint,
			method: 'POST',
			types: [SUBMIT_BACSDEBIT_PAYMENT_REVIEW_REQUEST, successAction, SUBMIT_BACSDEBIT_PAYMENT_REVIEW_FAILURE],
			body,
			headers: { 'x-bpi-version': endpoints.authorisation.x_bpi_version },
		},
	};
	return dispatch(action);
};
export const submitBacsDebitPaymentsForReview = (dispatch, getState) => {
	const state = getState();
	let paymentsRequireBeneficiary = isPayingInternalAccountsWithoutBeneficiary(state, 'bacsDebit');
	if (paymentsRequireBeneficiary.length > 0) {
		paymentsRequireBeneficiary = paymentsRequireBeneficiary.map((payment) => ({
			...payment,
			toAccount: payment.fromAccount,
			fromAccount: state.bacsDebit.toAccount,
		}));
		const bankId = getBankId(state);
		const { accounts } = state;
		return dispatch(submitBeneficiaries(bankId, paymentsRequireBeneficiary, accounts)).then(() =>
			submitBacsDebitReview(dispatch, getState)
		);
	}
	return submitBacsDebitReview(dispatch, getState);
};

export const submitConfirmedBacsDebitPayments = (bacsDetails, payees) => {
	const body = getBacsDebitConfirmedRequest(bacsDetails, payees);
	const endpoint = endpoints.createBacsDebit.resolve(null, null, bacsDetails.toAccount);

	return {
		[RSAA]: {
			endpoint,
			method: 'POST',
			types: [
				SUBMIT_CONFIRMED_BACSDEBIT_PAYMENTS_REQUEST,
				SUBMIT_CONFIRMED_BACSDEBIT_PAYMENTS_SUCCESS,
				SUBMIT_CONFIRMED_BACSDEBIT_PAYMENTS_FAILURE,
			],
			body,
			headers: { 'x-bpi-version': endpoints.createBacsDebit.x_bpi_version },
		},
	};
};

export const submitConfirmedEditedBacsDebitRequest = (bacsDetails, payees, paymentContextId) => {
	const body = getBacsDebitConfirmedRequest(bacsDetails, payees, paymentContextId);
	const endpoint = endpoints.createBacsDebit.resolve(null, null, bacsDetails.toAccount);

	return {
		[RSAA]: {
			endpoint,
			method: 'PUT',
			types: [
				SUBMIT_CONFIRMED_BACSDEBIT_PAYMENTS_REQUEST,
				SUBMIT_CONFIRMED_BACSDEBIT_PAYMENTS_SUCCESS,
				SUBMIT_CONFIRMED_BACSDEBIT_PAYMENTS_FAILURE,
			],
			body,
			headers: { 'x-bpi-version': endpoints.createBacsDebit.x_bpi_version },
		},
	};
};
export const submitConfirmedEditedBacsDebit = () => (dispatch, getState) => {
	const state = getState();
	const bacsDetails = getBacsDebitDetails(state);
	return dispatch(submitConfirmedEditedBacsDebitRequest(bacsDetails, state.payees, bacsDetails.context_id));
};

export const submitBacsDebitConfirmed = () => (dispatch, getState) => {
	const state = getState();
	if (isAuthorisationEdit(state)) {
		return dispatch(submitConfirmedEditedBacsDebit());
	}
	const bacsDebitDetails = getBacsDebitDetails(state);
	return dispatch(submitConfirmedBacsDebitPayments(bacsDebitDetails, state.payees));
};

export const acceptBacsDebitDateChangeAndResubmit = (dispatch, getState) => {
	const state = getState();
	const bacsDetails = getBacsDebitDetails(state);
	const { submission } = getReplacementDates(state);
	dispatch(updateBacsDebitSubmissionDate({ submissionDate: submission }));
	return dispatch(submitConfirmedBacsDebitPayments(bacsDetails, state.payees));
};
